import { useState, useEffect } from "react";

export function useCityIndexes(cityIndexes) {
  const [cityIndexArray, setCityIndexArray] = useState([]);

  useEffect(() => {
    if (cityIndexes) {
      let cityIndexArray = cityIndexes.split(",");
      let cleanedArray = cityIndexArray.map((item) => parseInt(item.trim())).filter(Boolean);
      setCityIndexArray(cleanedArray);
    }
  }, [cityIndexes]);

  return cityIndexArray;
}
